<template>
  <sui-page>
    <sui-page-header title="화면이동selectbox"></sui-page-header>
    <sui-page-contents>
      <div slot="top">
        <div class="pageSelectbox_wrap">
          <p>참조정보</p>
          <sui-custom-select 
          :value="{ label: '', key: '' }" 
          :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
          :use-popup="false"
          >
          </sui-custom-select >
        </div>
      </div>
      <div class="mrB50"></div>
      <pre>
         <code>
           &lt;div slot="top"&gt;
             &lt;div class="pageSelectbox_wrap"&gt;
               &lt;p&gt;참조정보&lt;/p&gt;
               &lt;sui-select :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"&gt;
               &lt;/sui-select&gt;
             &lt;/div&gt;
          &lt;/div&gt;

      </code>
    </pre>
    <div class="mrB50"/>
    <div class="processInfo_wrap">
      <ul>
        <li class="active"><span class="complete">1</span>프로세스01</li>
        <li><span class="normal">2</span>프로세스02</li>
        <li class="active"><span class="active">3</span>프로세스03</li>
      </ul>
    </div>
    <div class="processInfo_wrap">
      <ul>
        <li class="active"><span class="complete">1</span>프로세스01</li>
        <li><span class="complete">2</span>프로세스02</li>
        <li class="complete"><span class="normal">3</span>프로세스03</li>
        <li class="disable"><span class="normal">4</span>프로세스04</li>
        <li class="disable"><span class="complete">5</span>프로세스05</li>
      </ul>
    </div>



    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_FLY_00009',
  data() {
    return {
      // 차수 이동 Select Box [S]
      orderOptionList: [
        {
          key: 'A001',
          order: '1차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '진행중',
        },
        {
          key: 'A002',
          order: '2차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '미진행',
        },
        {
          key: 'A003',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '재요청',
        },
        {
          key: 'A004',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A005',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A006',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A007',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A008',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '미진행',
        },
        {
          key: 'A009',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
      ],
      // 차수 이동 Select Box [E]
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
  },
};
</script>
<style scoped>
  pre {
    background-color: #282C34;
    border: 1px solid #e4e4e4
  }
  code {
    font-family: AppleSDGothicNeo-Regular, "NanumGothic", dotum, "돋움체", sans-serif;
    font-size: 14px;
    color: #C8EBFA;
    line-height: 150%;
  }
</style>
